import styled from 'styled-components';

// Ocupa o espaço que sobra da coluna de PageContentProtocolos em vez de ter
// altura própria -- assim o embed não empurra a página para além da viewport,
// que era o que produzia uma segunda barra de rolagem por fora do iframe.
export const EmbedContainer = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const EmbedIframe = styled.iframe`
  display: block;
  flex: 1 1 auto;
  width: 100%;
  // Permite que o iframe encolha dentro do flex container em vez de estourar
  // a altura -- sem isso o scroll interno não acontece.
  min-height: 0;
  border: none;
`;
